
export async function handleOAuthCallback() {
  const location = window.location;
  console.log("Handling OAuth callback with hash:", location.hash);
  console.log("Handling OAuth callback with search:", location.search);
  console.log("Current URL:", window.location.href);
  console.log("Current origin:", window.location.origin);
  
  // Process hash parameters if present
  if (location.hash) {
    const hashParams = new URLSearchParams(location.hash.substring(1));
    const accessToken = hashParams.get("access_token");
    const refreshToken = hashParams.get("refresh_token");
    const error = hashParams.get("error");
    const errorDescription = hashParams.get("error_description");
    
    console.log("Parsed hash params:", { 
      accessToken: accessToken ? "Found" : "Not found", 
      refreshToken: refreshToken ? "Found" : "Not found", 
      error, 
      errorDescription 
    });
    
    if (accessToken || error) {
      // Clear the hash from the URL to prevent processing it again on refresh
      // but keep the path and search params
      const cleanUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;
      window.history.replaceState({}, document.title, cleanUrl);
      
      return {
        type: 'hash',
        accessToken,
        refreshToken,
        error,
        errorDescription
      };
    }
  }
  
  // Process search parameters if present
  if (location.search) {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const error = searchParams.get("error");
    
    console.log("Parsed search params:", { 
      code: code ? "Found" : "Not found", 
      error 
    });
    
    if (code || error) {
      // Don't clear the code from the URL as the Supabase client needs it
      // to exchange for a token in the PKCE flow
      
      return {
        type: 'search',
        code,
        error
      };
    }
  }
  
  console.log("No OAuth parameters found in URL");
  return null;
}

export const publicRoutes = ["/", "/auth", "/login", "/privacy-terms", "/learn-more", "/resources", "/blog", "/blog/"];

export function isPublicRoute(path: string): boolean {
  return publicRoutes.some(route => 
    path === route || path.startsWith('/privacy-terms') || 
    path.startsWith('/learn-more') || path.startsWith('/resources') ||
    path.startsWith('/blog')
  );
}
